import { Box } from "@mui/material";
import styled from "@emotion/styled";

export interface BlurredBackgroundImageProps {
    className?: string;
    imageUrl: string;
    blurSize: number;
}

const StyledContainer = styled(Box)({
    position: "absolute",
    inset: 0,
    overflow: "hidden",
});

const StyledBackgroundImage = styled(
    Box,
    {
        shouldForwardProp(propName) {
            return propName !== "blurSize";
        },
    }
)<Pick<BlurredBackgroundImageProps, "blurSize">>(({ blurSize }) => ({
    position: "absolute",
    inset: -blurSize,
    backgroundPosition: "center",
    backgroundSize: "cover",
    filter: `blur(${blurSize}px)`,
}));

const StyledBackdropShadow = styled(Box)({
    position: "absolute",
    inset: 0,
    backgroundImage: "linear-gradient(90deg, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.3))",
});

/**
 * blurred-background component
 */
export const BlurredBackgroundImage = ({ className, imageUrl, blurSize }: BlurredBackgroundImageProps) => (
    <StyledContainer className={className}>
        <StyledBackgroundImage
            className={className + "-image"}
            blurSize={blurSize}
            style={{ backgroundImage: `url(${imageUrl})` }}
        />
        <StyledBackdropShadow className={className + "-shadow"} />
    </StyledContainer>
);
